import _find from 'lodash/find';
import _each from 'lodash/each';

function Ctrl($scope, $state, $rootScope, $stateParams, $timeout, $location, metaTagService, tracking, membershipService, utilsService) {
  if (membershipService.isUserSubscribed()) {
    return $state.go('app.membership.perks');
  }

  $scope.typeformURL = 'https://tablelist-forms.typeform.com/to/gZr4xt';
  $scope.typeformPreviewURL = 'https://tablelist-forms.typeform.com/to/WhBCRZ';

  const query = $location.search();

  if (query) {
    if (!query.src) {
      query.src = 'www';
    }

    const params = utilsService.convertParamsToQueryString(query);

    $scope.typeformURL += params;
    $scope.typeformPreviewURL += params;
  }

  $scope.cities = membershipService.getCities();

  $scope.activeCity = $scope.cities[1];

  $scope.selectCity = function(slug) {
    $scope.activeCity = _find($scope.cities, {
      slug: slug
    });
  };

  $scope.venues = membershipService.getVenues();

  $scope.filterVenues = function(city) {
    return city.city === $scope.activeCity.slug;
  };

  $scope.perkHTML = function(perks) {
    const perksList = {
      'drink deals': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-drink-v1.0.png" alt="Drink Deals">Drink Deals</span>',
      'table deals': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-TL-v1.0.png" alt="Table Deals">Table Deals</span>',
      'line jumpers': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-entry-v1.0.png" alt="VIP Line Jumpers">VIP Line Jumpers</span>',
      'preferred pricing': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-TL-v1.0.png">Preferred Pricing</span>',
      'free entry': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-ticket-v1.0.png" alt="Free Entry">Free Entry</span>'
    };

    let html = '';

    _each(perks, function(perk) {
      html += perksList[perk];
    });

    return html;
  };

  $scope.shareBarConfig = {
    url: utilsService.createUrl('/membership'),
    message: 'Join @Tablelist Membership for exclusive members only experiences:'
  };

  metaTagService.set({
    title: 'Diamond Membership - The only nightlife membership program in the world.',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$rootScope',
  '$stateParams',
  '$timeout',
  '$location',
  'metaTagService',
  'trackingService',
  'membershipService',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/membershipLanding/membershipLandingCtrl.js